export default __webpack_public_path__ + "static/BC_Member_Logo_Green-Blue-20dad67e901d0985811daa36bf127754.jpg";